import { LockIcon } from 'lucide-react';

interface TaskLockedBannerProps {
  message: string;
}

export function TaskLockedBanner({ message }: TaskLockedBannerProps) {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2">
      <LockIcon size={13} className="shrink-0 text-amber-500" />
      <span className="text-xs text-amber-700">{message}</span>
    </div>
  );
}
